export default __webpack_public_path__ + "static/IconOnlyPadding-16bfedeb6fced41e2cdeeaad496263b1.png";